import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useGetDashboardDataQuery } from 'store/services/dashboard.service';

const PERIOD_TO_RANGE = {
    'Today': () => {
        const today = new Date().toISOString().slice(0, 10);
        return { start: today, end: today };
    },
    '7d':  () => offsetRange(7),
    '30d': () => offsetRange(30),
    '90d': () => offsetRange(90),
    '6m':  () => offsetRange(180),
    '12m': () => offsetRange(365),
};

function offsetRange(days) {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - days);
    return { start: start.toISOString().slice(0, 10), end: end.toISOString().slice(0, 10) };
}

export function resolveDateRange({ startDate, endDate, period }) {
    if (startDate && endDate) return { start: startDate, end: endDate };
    const fn = PERIOD_TO_RANGE[period] || PERIOD_TO_RANGE['90d'];
    return fn();
}

export default function useDashboardData(request, { skip = false } = {}) {
    const tenancyId = useSelector((s) => s.tenancy.tenancyId);

    const body = useMemo(() => {
        if (!request) return null;
        const { period, startDate, endDate, ...rest } = request;
        const dateRange = resolveDateRange({ startDate, endDate, period });
        return {
            tenancyId: Number(tenancyId),
            ...rest,
            filters: {
                ...(rest.filters || {}),
                dateRange,
            },
        };
    }, [request, tenancyId]);

    return useGetDashboardDataQuery(body, { skip: skip || !tenancyId || !body });
}
